// @flow @format
import React, {PureComponent, type Node} from 'react';
import PropTypes from 'prop-types';
import classNames from 'lib/classnames';
import './FileListBody.css';

type Props = {
	className: string,
	children?: Node,
	style: Object,
};

class FileListBody extends PureComponent<Props> {
	static defaultProps = {
		style: {},
		className: '',
	};

	static propTypes = {
		className: PropTypes.string,
		children: PropTypes.node.isRequired,
		style: PropTypes.object,
	};

	render() {
		const {children, className, style} = this.props;

		return (
			<div
				style={style}
				className={classNames('FileList__Body', className)}
			>
				{children}
			</div>
		);
	}
}

export default FileListBody;



// WEBPACK FOOTER //
// ./src/components/FileList/FileListBody.js